<template>
  <div id="mySidenav" class="sidenav d-block" v-if="filterTab" style="z-index:500">
    <div class="px-2" id="sidebar">
      <div class="filter-head mt-2 mb-4">
        <span class="filter-txt">Filter</span>
      </div>
      <div id="accordion" class="accordion-style mt-2">
        <div class="mb-3">
          <h5 class="mb-0 mtab">
            <div class="form-group ml-1">
              <label for="example" class="font-10">Ersteller</label>
              <input type="text" v-on:input="filterByCreator" v-model="creatorName" class="form-control w-100 sm-input" id="example" placeholder="Ersteller">
            </div>
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['searchString'],
  data () {
    return {
      creatorName: ''
    }
  },
  computed: {
    filterTab(){
      return  this.$store.state.constructionDiary.filterTab
    }
  },
  methods: {
    async filterByCreator(){
      this.$parent.currentPage = 1;
      this.$parent.selectedIndex = null
       let filters = {
        _explicitType: "com\\projectdocu\\PredicateOperatorAndVO",
         operands: []
       }

      let creator_filter = {
        _explicitType :"com\\projectdocu\\PredicateOperandLikeVO",
        fieldname: "creator", fieldvalue: `*${this.creatorName}*`
      }

      let searchQry =  {
        _explicitType :"com\\projectdocu\\PredicateOperandLikeVO",
        fieldname :"runid",fieldvalue: `${this.searchString}*`
      }

      if (this.creatorName.length){
        filters.operands.push(creator_filter);
      }
      if (this.searchString){
        filters.operands.push(searchQry);
      }
      let orderQry = [
        {
          "_explicitType":"com\\projectdocu\\OrderSettingVO",
          "fieldname":"runid",
          "order":"DESC"
        }
      ]

       let payload = { params: [ this.$route.params.id , 50 , 0, filters , orderQry ], is_paging: true }
       await this.$store.dispatch("getConstructionReports",payload)
     }
  },
  watch: {
    searchString: function (){
      this.filterByCreator();
    }
  }
}
</script>
<style scoped>
.sidenav {
  height: calc(100vh - 179px);
  left:0;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/SideBar/ConstructionFilterBar.vue